"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const FilterStateKeysEnum_1 = __importDefault(require("@react/web/Listing/Filter/FilterStateKeysEnum"));
const NumberFormatter_1 = __importDefault(require("@react/web/Common/NumberFormatter/NumberFormatter"));
const mergedOfferKeys = [
    FilterStateKeysEnum_1.default.body,
    FilterStateKeysEnum_1.default.make,
    FilterStateKeysEnum_1.default.model,
];
function createFilterPills(filterFormData, isMergedCarListingOffer, handleFilterChange, handleResetFilterClick) {
    const result = [];
    Object.keys(filterFormData).forEach((key) => {
        if (key === FilterStateKeysEnum_1.default.contractLength) {
            const activeItems = filterFormData.contractLength.filter((item) => item.active);
            const selectedContractLengths = activeItems.map((item) => item.value);
            const labelFrom = selectedContractLengths[0];
            const labelTo = NumberFormatter_1.default.formatMonths(Number(selectedContractLengths[selectedContractLengths.length - 1]));
            if (selectedContractLengths.length === 0) {
                return;
            }
            result.push(react_1.default.createElement("span", { className: "filter-pill", onClick: () => handleFilterChange([], key), title: "Odstranit filtr", key: "contract-length-filter-pill" }, `${selectedContractLengths.length > 1 ? `${labelFrom} - ` : ''}${labelTo}`));
        }
        else {
            filterFormData[key].forEach((filterFormDataItem) => {
                if (filterFormDataItem.active === false) {
                    return;
                }
                if (isMergedCarListingOffer === true && mergedOfferKeys.includes(key) === true) {
                    result.push(react_1.default.createElement("span", { className: "filter-pill disabled", key: `${filterFormDataItem.value}-filter-pill` }, filterFormDataItem.label));
                }
                else {
                    result.push(react_1.default.createElement("span", { className: "filter-pill", onClick: () => handleFilterChange(filterFormDataItem, key), title: "Odstranit filtr", key: `${filterFormDataItem.value}-filter-pill` }, filterFormDataItem.label));
                }
            });
        }
    });
    if (result.length === 0) {
        return result;
    }
    result.push(react_1.default.createElement("a", { href: "#", onClick: (event) => handleResetFilterClick(event), className: "filter-pill-reset", key: "reset-filter-pill" }, "Zru\u0161it v\u0161echny filtry"));
    return result;
}
const FilterPillsView = ({ filterFormData, handleFilterChange, handleResetFilterClick, isMergedCarListingOffer, }) => react_1.default.createElement("div", { className: "listing-filter-pills" }, createFilterPills(filterFormData, isMergedCarListingOffer, handleFilterChange, handleResetFilterClick));
exports.default = FilterPillsView;
